// ** Router Import
import Router from './router/Router'
// import FeedbackButton from '@components/feedback-button'

const App = (props) => {
  return (
    <>
      <Router />
      {/* <FeedbackButton /> */}
    </>
  )
}

export default App
